export const environment = {
  production: false,
  apiUrl: "https://apidev.clearline.me",
  selfServicePortalUrl: "https://clearline-test.chargebee.com/portal/v2/home",
  authConfig: {
    clientId: "clm-admin-client",
    scope: "clearline_api",
    redirectUrl: "/callback",
    logoutUrl: ""
  },
  pubNubConfig: {
    publishKey: "pub-c-49be0225-04f0-4540-86e8-4a96f075de7f",
    subscribeKey: "sub-c-a9784f38-15d4-4e85-be21-a1c4cc2d1973",
    uuid: "app-963D6563141149D888F04D661BB14D7E",
    cfsUuid: "app-8E66A4AAEBE24C1683D9022E5EBFB231"
  },
  helpHeroAppId: "Aa7eTXxk64"
};
